import ConfiguracionesGeneralesEdit from './ConfiguracionesGeneralesEdit';

const indexConfiguracionesGenerales = {
    edit: ConfiguracionesGeneralesEdit,
};

export default indexConfiguracionesGenerales;
